import React, { useState, useEffect, useMemo } from 'react';
import { useCollection } from '../hooks/useCollection';
import { Link } from "react-router-dom";
import ProjectSort from './sortedValues/ProjectSort';
import '../pages/completed/Completed.css';
import './ProjectList.css';

const CompletedGradeNeeded = () => {
    const compare = null;
    const { documents, error } = useCollection('projects', 'grade', '==', compare, 'completedDate', 'asc');

    // Load saved sort preference from localStorage
    const [sortBy, setSortBy] = useState(() => {
        const savedSort = localStorage.getItem('needsGradedSortPreference');
        return savedSort || 'completedDate-desc';
    });

    // Save sort preference to localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem('needsGradedSortPreference', sortBy);
    }, [sortBy]);

    // Filter and sort assignments that need grading
    const sortedProjects = useMemo(() => {
        if (!documents) return [];

        // Filter: must be completed but have no grade
        const filtered = documents.filter(project => project.completed);

        // Sort based on sortBy preference
        return filtered.sort((a, b) => {
            switch (sortBy) {
                case "completedDate-asc":
                    return a.completedDate.toDate() - b.completedDate.toDate();
                case "completedDate-desc":
                    return b.completedDate.toDate() - a.completedDate.toDate();
                case "dueDate-asc":
                    return a.dueDate.toDate() - b.dueDate.toDate();
                case "dueDate-desc":
                    return b.dueDate.toDate() - a.dueDate.toDate();
                case "createdAt-asc":
                    return a.createdAt.toDate() - b.createdAt.toDate();
                case "createdAt-desc":
                    return b.createdAt.toDate() - a.createdAt.toDate();
                case "category":
                    return a.category.localeCompare(b.category);
                case "title":
                    return a.title.localeCompare(b.title);
                default:
                    return 0;
            }
        });
    }, [documents, sortBy]);

    return (
        <>
            <div className="page-header">
                <h2 className="page-title">Completed Assignments Needing Grades</h2>
                <ProjectSort sortBy={sortBy} onSortChange={setSortBy} />
            </div>

            {error && <p className="error">{error}</p>}

            <div className='project-list completed'>
                {sortedProjects.length === 0 && <p>None!</p>}
                {sortedProjects.map(project => (
                    <Link to={`/projects/${project.id}`} key={project.id}>
                        <h4 style={{ textTransform: 'capitalize' }}>{project.title}</h4>
                        <p style={{ textTransform: 'capitalize' }}>{project.category}</p>
                        <p>Completed: {project.completedDate.toDate().toDateString()}</p>
                        <p className="needs-grade-indicator">⚠️ Needs Grade</p>
                    </Link>
                ))}
            </div>
        </>
    );
};

export default CompletedGradeNeeded;